import LicenseLinkedFormCompleter from "./licenseLinkedFormCompleter";
import License from "../license";
import Guid from "~/helpers/guid";
import Vue from "vue";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";
import LicenseBuilderSortable from "../licenseBuilderSortable";
import {RelationType} from "../../../../common/models/relationType";
import LicenseLinkedFormViewer from "./licenseLinkedFormViewer";
import {DurationUnit} from "../../../../common/enums/durationUnit";
import {DurationType} from "../../../../common/enums/durationType";
import RelativeTimePeriod from "../../../../common/models/relativeTimePeriod";

export default class LicenseLinkedForm extends LicenseBuilderSortable {
    form_id: string;
    form_completers: {[key: string]: LicenseLinkedFormCompleter} = {};
    generation_status_client_ids: string[];
    restrict_form_viewers: boolean;
    form_viewers: {[key: string]: LicenseLinkedFormViewer} = {};
    autogenerate: boolean;
    autogeneration_interval_amount: number;
    autogeneration_interval_amount_formula: string;
    autogeneration_interval_unit: DurationUnit;
    generated_at: RelativeTimePeriod;
    generation_period_end: RelativeTimePeriod;

    except = ['license', 'form_completers', 'form_viewers', 'generated_at', 'generation_period_end'];

    static repo: IRepo<LicenseLinkedForm> = new Repo<LicenseLinkedForm>('licenseLinkedForms', LicenseLinkedForm);

    constructor(license: License, json: any = {}) {
        super();
        this.defineProperty('client_id', json["client_id"] || Guid.create());
        this.defineProperty('form_id', null);
        this.defineProperty('generation_status_client_ids', []);
        this.defineProperty('restrict_form_viewers', false);
        this.defineProperty('autogenerate', false);
        this.defineProperty('autogeneration_interval_amount', 1);
        this.defineProperty('autogeneration_interval_amount_formula', null);
        this.defineProperty('autogeneration_interval_unit', null);
        this.defineProperty('sort_order', license.nextSortOrderFor(this.rootName));
        this.rootModel = license;
        this.parent = license;
        this.license = license;

        LicenseLinkedForm.repo.add(this);
        Vue.set(license.linked_forms, this.client_id, this);

        this.loadFromJson(json, license.rootModel);
        if (!this.generated_at) {
            const period = new RelativeTimePeriod(this, "generated_at");
            this.trackCreationDeletion(period.client_id, null, period.asJson(), period);
        }
        if (!this.generation_period_end) {
            const period = new RelativeTimePeriod(this, "generation_period_end", {type: DurationType.never});
            this.trackCreationDeletion(period.client_id, null, period.asJson(), period);
        }
    }

    get formCompletersArray(): LicenseLinkedFormCompleter[] {
        return Object.keys(this.form_completers).map(key => this.form_completers[key]);
    }

    get formViewersArray(): LicenseLinkedFormViewer[] {
        return Object.keys(this.form_viewers).map(key => this.form_viewers[key]);
    }

    get rootName(): string {
        return 'linked_forms';
    }

    get displayName(): string {
        return 'License Linked Forms';
    }

    get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
        return {
            'form_completers': { type: LicenseLinkedFormCompleter, relationType: RelationType.dictionary },
            'form_viewers': { type: LicenseLinkedFormViewer, relationType: RelationType.dictionary },
            'generated_at': { type: RelativeTimePeriod, relationType: RelationType.singleObject },
            'generation_period_end': { type: RelativeTimePeriod, relationType: RelationType.singleObject },
        };
    }

    createEmbeddedObject = {
        form_completers: (parent, json): LicenseLinkedFormCompleter => { return new LicenseLinkedFormCompleter(parent);},
        form_viewers: (parent, json): LicenseLinkedFormViewer => { return new LicenseLinkedFormViewer(parent);},
        generated_at: (parent: LicenseLinkedForm, json): RelativeTimePeriod => { return new RelativeTimePeriod(parent, 'generated_at', json); },
        generation_period_end: (parent: LicenseLinkedForm, json): RelativeTimePeriod => { return new RelativeTimePeriod(parent, 'generation_period_end', json); },
    };

    get isCollectionRoot(): boolean {
        return true;
    }
}